<template>
	<div>
		<div :class="`AnswerOptionBar AnswerOptionBar--text-${textPosition}`">
			<div class="AnswerOptionBar__header clearfix">
				<div v-if='textPosition == "top"'>
					<!-- @vue-expect-error -->
					<div
						class="AnswerOptionBar__text pull-left text-left"
						v-html="JSON.parse(answerOptionText)"
					></div>
				</div>
				<div
					v-if='showResultAs == "count"'
					class="AnswerOptionBar__percentage pull-left text-right"
				>
					<animated-number
						:prev-number="0.0"
						:key='"percentageOfTotal-" + answerOptionId'
						:number="attemptsCountForOption"
						:animation-duration="1"
						:dont-floor="false"
					></animated-number>
				</div>
				<div
					v-if='showResultAs == "percentage"'
					class="AnswerOptionBar__percentage pull-left text-right"
				>
					<animated-number
						:prev-number="0.0"
						:key='"percentageOfTotal-" + answerOptionId'
						:number="percentageOfTotalAnswers.toFixed()"
						:animation-duration="1"
						:dont-floor="false"
					></animated-number>
					%
				</div>
			</div>
			<div class="AnswerOptionBar__bar">
				<!-- There are 13 "dark pastel" colors -->
				<!-- @vue-expect-error -->
				<div
					:class="`AnswerOptionBar__bar-inner dark-pastel-${(index % 13) + 1}-bg`"
					:style="{ width: `${percentageOfTotalAnswers}%` }"
				></div>
			</div>
			<div v-if='textPosition == "bottom"'>
				<div
					class="AnswerOptionBar__text pull-left text-left"
					v-html="answerOptionText"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import AnimatedNumber from "../properties_components/animated_number.vue";
// Other components
import { i18n } from "../utils";

export default {
	mixins: [i18n],
	props: {
		questionId: Number,
		answerOptionId: Number,
		answerOptionText: String,
		showResultAs: String,
		textPosition: String,
		srvTotalAttemptsForQuestion: Number,
		srvAttemptsCountForOption: Number,
		index: Number,
	},
	components: {
		"animated-number": AnimatedNumber,
	},
	data: function () {
		return {
			totalAttemptsForQuestion: this.srvTotalAttemptsForQuestion,
			attemptsCountForOption: this.srvAttemptsCountForOption,
		};
	},
	computed: {
		percentageOfTotalAnswers: function () {
			if (this.totalAttemptsForQuestion == 0) {
				return 0;
			}
			return (
				// @ts-expect-error
				(this.attemptsCountForOption / this.totalAttemptsForQuestion) * 100
			);
		},
		locale: function () {
			return I18n.locale;
		},
	},
	mounted() {
		// pp.log(
		// 	`Component Props:\n` +
		// 	`Question ID: ${this.questionId}\n` +
		// 	`Answer Option ID: ${this.answerOptionId}\n` +
		// 	`Answer Option Text: ${this.answerOptionText}\n` +
		// 	`Show Result As: ${this.showResultAs}\n` +
		// 	`Text Position: ${this.textPosition}\n` +
		// 	`Total Attempts for Question (from server): ${this.srvTotalAttemptsForQuestion} \n` +
		// 	`Attempts Count for Option (from server): ${this.srvAttemptsCountForOption} \n` +
		// 	`Index: ${this.index}`
		// );
		pp.vue.bus.$on("answer_attempt-CREATE", this.onIncomingAnswerAttempt);
	},
	beforeDestroy() {
		pp.vue.bus.$off("answer_attempt-CREATE", this.onIncomingAnswerAttempt);
	},
	methods: {
		onIncomingAnswerAttempt(answerAttempt) {
			if (answerAttempt.answer_option.question_id != this.questionId) {
				return;
			}
			// @ts-expect-error
			this.totalAttemptsForQuestion = this.totalAttemptsForQuestion + 1;
			if (answerAttempt.answer_option_id == this.answerOptionId) {
				// @ts-expect-error
				this.attemptsCountForOption = this.attemptsCountForOption + 1;
			}
		},
	},
};
</script>
